import dayjs from 'dayjs';
import { recapQueryKeys } from './recapQueryKeys.js';
import { isQueryEnabled } from '@fabric-app/queries/utilities';
import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { useQueryUserInfo } from '../../user/queries/useQueryUserInfo.js';
import { useWoody } from '../../woody/woody.js';

const useQueryRecapForDate = (options, queryOptions) => {
  const { data: user } = useQueryUserInfo();
  const { client } = useWoody();
  const isLoggedIn = !!user;
  const date = options.date;
  const field = options.field || "created";
  const query = useQuery({
    queryKey: recapQueryKeys.recapForDate(user?.id, date, field),
    queryFn: async (params) => {
      const safeStartDate = params.queryKey[2];
      return client.v2("/v2/recap/by-date", {
        method: "get",
        query: {
          date: dayjs(safeStartDate).format("YYYY-MM-DD"),
          field
        }
      });
    },
    placeholderData: keepPreviousData,
    ...queryOptions,
    // long stale time if the date is from before today
    staleTime: dayjs(date).isBefore(dayjs(), "date") ? 1e3 * 60 * 60 * 3 : 1e3 * 30,
    enabled: isQueryEnabled([
      isLoggedIn,
      queryOptions?.enabled,
      !!user?.id,
      !!date
    ]),
    retry: 3
  });
  return query;
};

export { useQueryRecapForDate };
//# sourceMappingURL=useQueryRecapForDate.js.map
